import { useEffect, useState } from "react";
import { Users, Ruler } from "@phosphor-icons/react";
import api from "../../lib/api";
import MetricsPanel from "../../components/MetricsPanel";

export default function TrainerMetrics() {
  const [clients, setClients] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/clients");
        setClients(data);
        if (data.length && !selectedId) setSelectedId(data[0].id);
      } catch (_e) { /* ignore */ }
    })();
    // eslint-disable-next-line
  }, []);

  const selected = clients.find((c) => c.id === selectedId);

  return (
    <div className="space-y-8" data-testid="trainer-metrics-page">
      <div>
        <div className="tracker text-brand mb-3">[ Body metrics ]</div>
        <h1 className="font-display text-4xl sm:text-5xl">Progress.</h1>
        <p className="text-zinc-500 mt-2">Log weight and body fat for each client. Performance tests (bike, dead hang, broad jump…) live on the Assessment tab.</p>
      </div>

      <div className="grid lg:grid-cols-[280px_1fr] gap-6">
        {/* Client picker */}
        <div className="card-flat p-3 h-fit">
          <div className="tracker text-zinc-500 px-2 py-1 flex items-center gap-2">
            <Users size={12} weight="bold" /> Clients ({clients.length})
          </div>
          <div className="mt-2 max-h-[60vh] overflow-y-auto">
            {clients.length === 0 ? (
              <div className="text-zinc-600 text-xs px-2 py-4 italic">No clients yet.</div>
            ) : (
              clients.map((c) => (
                <button
                  key={c.id}
                  onClick={() => setSelectedId(c.id)}
                  className={`w-full text-left px-3 py-2.5 border-l-2 hover:bg-white/5 ${selectedId === c.id ? "border-brand bg-brand/10" : "border-transparent"}`}
                  data-testid={`metric-client-${c.id}`}
                >
                  <div className="font-semibold text-sm">{c.name}</div>
                  <div className="font-mono text-[10px] text-zinc-500">{c.email}</div>
                </button>
              ))
            )}
          </div>
        </div>

        {/* Panel */}
        <div>
          {selected ? (
            <MetricsPanel
              key={selected.id}
              clientId={selected.id}
              clientName={selected.name}
              canEdit={true}
              unit="kg"
            />
          ) : (
            <div className="card-flat p-10 text-center text-zinc-500">
              <Ruler size={32} weight="duotone" className="mx-auto mb-3 text-brand" />
              Pick a client to view and log measurements.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
